import React from "react";
import SubList from "./_support/SubList";
import TableInput from "../forms/formElements/TableInput";
import TableInputRow from "../forms/formElements/TableInputRow";
import BooleanInput from "../forms/formElements/BooleanInput";
import StringInput from "../forms/formElements/StringInput";
import ComboBox from "../forms/formElements/ComboBox";

const headers = ["Názov", "Ulica", "Mesto", "PSČ", "Hlavná Adresa"]

function Addresses(props) {
    let data = [...props.data['Adresa'], {
        'Nazov': '',
        'Mesto': '',
        'Ulica': '',
        'PSC': '',
        'Hlavna_Adresa': false
    }]
    return (
        <SubList label="Adresy">
            <TableInput headers={headers} delete={props.delete}>
                {data.map((item, index) => (
                    <TableInputRow delete={index === data.length - 1 ? null : props.delete} ndx={index} index={0}>
                        <StringInput name={'Nazov'}
                                     value={item.Nazov}
                                     onChange={event => props.updateAddress(event, index)}/>
                        <StringInput name={'Ulica'}
                                     value={item.Ulica}
                                     onChange={event => props.updateAddress(event, index)}/>
                        <StringInput name={'Mesto'}
                                     value={item.Mesto}
                                     onChange={event => props.updateAddress(event, index)}/>
                        <StringInput name={'PSC'}
                                     value={item.PSC}
                                     onChange={event => props.updateAddress(event, index)}/>
                        <BooleanInput name={'Hlavna_Adresa'}
                                      value={item.Hlavna_Adresa}
                                      onChange={event => props.updateAddress(event, index)}/>
                    </TableInputRow>
                ))
                }
            </TableInput>
        </SubList>
    )
}

export default Addresses
